import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFunctions, httpsCallable } from "firebase/functions";

const config = {
    apiKey: import.meta.env.VITE_FB_KEY,
    authDomain: "gamably-app.firebaseapp.com",
    projectId: "gamably-app",
    storageBucket: "gamably-app.appspot.com",
    messagingSenderId: "22760211792",
    appId: "1:22760211792:web:aa67703c11064122b0d855",
    measurementId: "G-7GS30LCXSH"
};

const app = initializeApp(config);

/**
 * 
 * AUTHENTICATION
 * 
 */


export const auth = getAuth(app);
const provider = new GoogleAuthProvider();

/**
 * 
 * EXPORT DATABASE REFS
 * 
 */

export const db = getFirestore();

export const rtDb = getDatabase();

/**
 * 
 * SIGN OUT
 * 
 */

export const signOut = async () => {
	await auth.signOut();
	return true;
}

/**
 *
 * Use Cloud Function
 *
 */

/**
 * Shared cloud-function caller. Catches transport/backend errors and returns
 * them as { error, code, details } so every caller can rely on a single
 * `if (res.error)` check instead of wrapping calls in try/catch. On success
 * returns the backend payload (normalized to {} if it comes back empty).
 */
const callCloud = async (callableName, command, data, { includeTimezone = true } = {}) => {
	console.log(callableName, command);
	const functions = getFunctions();
	const callable = httpsCallable(functions, callableName);
	const payload = { command, data };
	if (includeTimezone) {
		payload.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; // e.g. "America/Chicago"
	}
	try {
		const result = await callable(payload);
		return result.data ?? {};
	} catch (error) {
		console.error(`Cloud call failed [${callableName}:${command}]`, error.code, error.message, error.details);
		return {
			error: error.message || 'An unexpected error occurred. Please try again.',
			code: error.code || 'unknown',
			details: error.details ?? null,
		};
	}
}

export const UseCloudFunction = (command, data) => callCloud('processCommandsV2', command, data);

export const UseCloudGameTransactions = (command, data) => callCloud('gameTransactions', command, data);

export const UseCloudAdminFn = (command, data) => callCloud('adminFunctions', command, data, { includeTimezone: false });